module.exports = __webpack_public_path__ + "static/img/KIT-FILM-PURE-ZONE-A-POSER-SOI-MEME.98ef7e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/produits/KIT-FILM-PURE-ZONE-A-POSER-SOI-MEME.jpg
// module id = VHPO
// module chunks = 0